import { Box, Text } from '@mediahuis/chameleon-react';
import { MultibrandIcon } from "../MultibrandIcon/index.js";
import { MultibrandLogos } from "../MultibrandLogos/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const sortedBrands = ['nb', 'ds', 'gva', 'hbvl', 'dg'];
const MultibrandBanner = _ref => {
  let {
    activeBrand,
    style = {},
    text
  } = _ref;
  return /*#__PURE__*/_jsxs(Box, {
    bgColor: "colorGrey10",
    display: "grid",
    mr: 6,
    py: 5,
    style: {
      borderBottomRightRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
      columnGap: '16px',
      gridTemplateColumns: 'auto 1fr',
      paddingLeft: '10%',
      paddingRight: '10%',
      rowGap: '6px',
      ...style
    },
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        alignItems: 'center',
        display: 'flex'
      },
      children: /*#__PURE__*/_jsx(MultibrandIcon, {
        icon: "plusBlack",
        height: "12px",
        width: "12px"
      })
    }), /*#__PURE__*/_jsx(Text, {
      fontFamily: "system",
      fontWeight: "bold",
      size: "Caption1",
      children: text
    }), /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx(MultibrandLogos, {
      brands: sortedBrands.filter(brand => brand !== activeBrand)
    })]
  });
};
export default MultibrandBanner;